<template>
    <v-card class="pa-4 k-card-border mb-4">
        <div v-if="daysLeft > 0">
            <p class="mb-2" v-if="isTrial">
                Je zit nog <strong>{{ daysLeft }}</strong> dag<span v-if="daysLeft > 1">en </span>
                <span v-if="isTrial">in je proefperiode.</span>
            </p>

            <p>
                Huidig abonnement:
                <strong>{{ activePlan.name || "Geen abonnement" }}</strong>
            </p>

            <p v-if="isTrial">Trial eindigt op: {{ formatDate(activePlan.trial_ends_at) }}</p>
            <p v-else-if="hasSubscription" class="text-disabled">
                Abonnement loopt tot: {{ formatDate(activePlan.cycle_ends_at) }}
            </p>
        </div>

        <div v-else>
            <p class="mb-2 text-error">
                {{ isTrial ? "Je proefperiode is verlopen." : "Je abonnement is verlopen." }}
            </p>
        </div>
        <v-btn class="btn btn-sm" block color="primary" @click="goToCheckout">
            {{ buttonLabel }}
        </v-btn>
    </v-card>
</template>

<script>
import { format } from "date-fns";
import { useMainStore } from "@/stores/store";

export default {
    name: "TrialCard",

    computed: {
        // Pinia store
        mainStore() {
            return useMainStore();
        },

        // De workspace mét subscription
        workspace() {
            return this.mainStore.workspace || {};
        },

        // De ingeladen subscription
        activePlan() {
            return this.mainStore.getActiveSubscription;
        },

        // Heeft een lopende subscription?
        hasSubscription() {
            return !!this.activePlan.cycle_ends_at;
        },

        // Zitten we nog in trial?
        isTrial() {
            return !!this.activePlan.trial_ends_at;
        },

        // Bereken resterende dagen
        daysLeft() {
            const now = Date.now();

            // 1) Trial first
            if (this.activePlan.trial_ends_at) {
                const end = new Date(this.activePlan.trial_ends_at).getTime();
                return Math.max(0, Math.ceil((end - now) / (1000 * 60 * 60 * 24)));
            }

            // 2) Dan abonnement
            if (this.activePlan.cycle_ends_at) {
                const end = new Date(this.activePlan.cycle_ends_at).getTime();
                return Math.max(0, Math.ceil((end - now) / (1000 * 60 * 60 * 24)));
            }

            // 3) Fallback 30-dagen trial vanaf created_at
            if (this.workspace.created_at) {
                const created = new Date(this.workspace.created_at).getTime();
                const passed = Math.floor((now - created) / (1000 * 60 * 60 * 24));
                return Math.max(0, 30 - passed);
            }

            return 0;
        },
        buttonLabel() {
            return this.hasSubscription ? "Upgrade abonnement" : "Abonnement nemen";
        },
    },

    methods: {
        goToCheckout() {
            this.$router.push("/checkout?trial-ends=true");
        },
        formatDate(dateString) {
            return format(new Date(dateString), "dd-MM-yyyy");
        },
    },

    mounted() {
        this.mainStore.fetchActiveWorkspace();
    },
};
</script>
